import React, { Component } from 'react';
import { Tabs, Tab, Grid, Cell, Card, CardTitle, CardText, CardActions, Button, CardMenu, IconButton } from 'react-mdl';
import { Link } from 'react-router-dom';

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = { activeTab: 0 };
  }

  toggleCategories() {
    if(this.state.activeTab === 0){
      return(
        <div>
          <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.imgur.com/9ahdY4H.png) center / cover'}} >
              Senior Project CRM
            </CardTitle>
            <CardText>
              A MERN stack web application for the client to manage customer relationships.
            </CardText>
            <CardActions border>
              <Button colored>
                <a href="https://github.com/limmil/inspired-crm" rel="noopener noreferrer" target="_blank">
                  GitHub
                </a>
              </Button>
              {/*<Button colored>
                 <a href="https://tsg-crm.herokuapp.com/" rel="noopener noreferrer" target="_blank">
                   Demo
                 </a>
               </Button> */}
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          </div>
          <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.imgur.com/9ahdY4H.png) center / cover'}} >
              React Snake
            </CardTitle>
            <CardText>
              Simple web game made by using both React.js and CSS. 
              Use the arrow keys to control the snake.
            </CardText>
            <CardActions border>
              <Link to='/snakegame'>
                  <Button colored>
                      <a href='/#/snakegame'>Demo</a>
                  </Button>
              </Link>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          </div>
        </div>
      );
    } else if(this.state.activeTab === 1) {
      return (
        <div>
          <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#000', height: '176px', background: 'url(https://i.imgur.com/kS5Id9I.png) center / cover'}} >
              Calculator App
            </CardTitle>
            <CardText>
              This app is made in Android Studio using java.
            </CardText>
            <CardActions border>
              <Button colored>
              <a href="https://github.com/limmil/real_calculator" rel="noopener noreferrer" target="_blank">
                  GitHub
                </a>
              </Button>
              {/*<Button colored>
                <a href="https://play.google.com/store/apps/details?id=com.limmil.real_calculator" rel="noopener noreferrer" target="_blank">
                  Google Play
                </a>
              </Button> */}
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          </div>
          <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#000', height: '176px', background: 'url(https://i.imgur.com/kS5Id9I.png) center / cover'}} >
              Java Game Asteroids
            </CardTitle>
            <CardText>
              A game made by using Java in eclipse with codenameone. 
              The game is designed by using the MVC model 
              and the Object Oriented Programming approach.
            </CardText>
            <CardActions border>
              <Button colored>
                <a href="https://github.com/limmil/A3Prj" rel="noopener noreferrer" target="_blank">
                  GitHub
                </a>
              </Button>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          </div>
          <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#000', height: '176px', background: 'url(https://i.imgur.com/kS5Id9I.png) center / cover'}} >
              Attendance Tracker
            </CardTitle>
            <CardText>
              Software solution for educators at CSUS to track student attendance using Google Sheets API as database.
            </CardText>
            <CardActions border>
              <Button colored>
                <a href="https://github.com/limmil/Tracker" rel="noopener noreferrer" target="_blank">
                  GitHub
                </a>
              </Button>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          </div>
        </div>
      )
    } else if(this.state.activeTab === 2) {
      return (
        <div>
          <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.imgur.com/Ds3IYsL.png) center / cover'}} >
              Machine Learning Project
            </CardTitle>
            <CardText>
              Used artificial intelligence to predict automobile fatalities and find the highest contributing factors. The increased awareness of the risks could potentially lead to the decrease of automobile fatalities.
            </CardText>
            <CardActions border>
              <Button colored>
                <a href="https://github.com/limmil/Automobile-Fatalities-Analytics" rel="noopener noreferrer" target="_blank">
                  GitHub
                </a>
              </Button>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          </div>
          <div className="projects-grid">
          <Card shadow={5} style={{minWidth: '450', margin: 'auto'}}>
            <CardTitle style={{color: '#fff', height: '176px', background: 'url(https://i.imgur.com/Ds3IYsL.png) center / cover'}} >
              Data Mining Project
            </CardTitle>
            <CardText>
              This is the data mining project done using python in jupyter notebook.
            </CardText>
            <CardActions border>
              <Button colored>
                <a href="https://github.com/limmil/DataMiningProject" rel="noopener noreferrer" target="_blank">
                  GitHub
                </a>
              </Button>
            </CardActions>
            <CardMenu style={{color: '#fff'}}>
              <IconButton name="share" />
            </CardMenu>
          </Card>
          </div>
        </div>
      )
    }

  }



  render() {
    return(
      <div>
        <Tabs activeTab={this.state.activeTab} onChange={(tabId) => this.setState({ activeTab: tabId })} ripple>
          <Tab>React</Tab>
          <Tab>Java</Tab>
          <Tab>Python</Tab>
        </Tabs>


          <Grid>
            <Cell col={12}>
              <div className="content">{this.toggleCategories()}</div>
            </Cell>
          </Grid>


      </div>
    )
  }
}

export default Projects;
